import { EmbedProcessors } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_ProductContent/helpers/embed-processors.ts';
import {
  EmbedConfig,
  EmbedServiceName,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_ProductContent/types.ts';

export const embedConfigs: Record<EmbedServiceName, EmbedConfig> = {
  youtube: {
    name: 'youtube',
    desc: '유튜브 동영상, 쇼츠 등의 URL을 입력해 주세요.',
    img_url: '//s3.marpple.co/files/u_2308668/2025/7/original/538a7ba7c1d9a7a198ac0e449cfc2d78c7ffaa155.svg',
    validate: (url: string) => {
      return /youtu(?:\.be|be\.com)/.test(url);
    },
    process: async (url: string) => {
      return EmbedProcessors.makeYoutubeEmbedHtml(url);
    },
  },

  instagram: {
    name: 'instagram',
    desc: '인스타그램 게시글, 릴스 등의 URL을 입력해 주세요.',
    img_url: '//s3.marpple.co/files/u_2308668/2025/7/original/3b897dd0cc91ae9112fb6b5b8a7360251f45f32a2.svg',
    validate: (url: string) => {
      return /instagram\.com\/(p|reel|tv)\//.test(url);
    },
    process: async (url: string) => {
      const result = await EmbedProcessors.processInstagramEmbed(url);
      if (result.success && result.html) {
        return result.html;
      }
      throw new Error(result.error || 'Instagram 처리 중 오류가 발생했습니다.');
    },
  },

  tiktok: {
    name: 'tiktok',
    desc: '틱톡 동영상의 URL을 입력해 주세요.',
    img_url: '//s3.marpple.co/files/u_2308668/2025/7/original/7b06dcad03ab0cdcbe77a500456211657ff0e7183.svg',
    validate: (url: string) => {
      return /tiktok\.com\/@[\w.-]+\/video\/\d+/.test(url);
    },
    process: async (url: string) => {
      const result = await EmbedProcessors.processTikTokEmbed(url);
      if (result.success && result.html) {
        return result.html;
      }
      throw new Error(result.error || 'TikTok 처리 중 오류가 발생했습니다.');
    },
  },

  x: {
    name: 'x',
    desc: 'X(트위터) 게시글의 URL을 입력해 주세요.',
    img_url: '//s3.marpple.co/files/u_2308668/2025/7/original/e48c422a57083ae178b79680d95732996adab04b4.svg',
    validate: (url: string) => {
      return /(x\.com|twitter\.com)\/\w+\/status\/\d+/.test(url);
    },
    process: async (url: string) => {
      const result = await EmbedProcessors.processTwitterEmbed(url);
      if (result.success && result.tweetId) {
        // Twitter는 실제 위젯 생성이 필요하므로 일단 placeholder HTML 반환
        return `<div class="tw-embed" data-href="${url}" data-tweet-id="${result.tweetId}"></div>`;
      }
      throw new Error(result.error || 'X(Twitter) 처리 중 오류가 발생했습니다.');
    },
  },

  facebook: {
    name: 'facebook',
    desc: '페이스북 게시글의 URL을 입력해 주세요.',
    img_url: '//s3.marpple.co/files/u_2308668/2025/7/original/915adc93e38d34cabbb596b662ced0e28fc1267d1.svg',
    validate: (url: string) => {
      return /facebook\.com/.test(url);
    },
    process: async (url: string) => {
      const result = await EmbedProcessors.processFacebookEmbed(url);
      if (result.success && result.html) {
        return result.html;
      }
      throw new Error(result.error || 'Facebook 처리 중 오류가 발생했습니다.');
    },
  },
};
